import { useEffect, useState } from "react";

/** true quando a largura da viewport está abaixo de `breakpoint` (default 768px). */
export function useIsMobile(breakpoint = 768): boolean {
  const get = () =>
    typeof window !== "undefined" && window.innerWidth < breakpoint;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const onResize = () => setIsMobile(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);
  return isMobile;
}
